module.exports = __webpack_public_path__ + "static/img/evidence5.ae4b595.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/evidence5.png
// module id = TPpg
// module chunks = 1 3